// pt-BR of the Server Guardian section; complete for every key of en-guardian.ts (checked by the type).
import type { enGuardian } from "./en-guardian.ts";

export const ptBRGuardian: Record<keyof typeof enGuardian, string> = {
  "guardian.title": "Guardião do servidor",
  "guardian.subtitle": "Vigia o servidor Coolify onde o MaestrOS roda e os apps que ele publicou: quedas, deploys com falha, erros de dependência nos logs, disco e memória.",
  "guardian.runNow": "Rodar agora",
  "guardian.runQueued": "Uma verificação do guardião foi enfileirada; o worker a executa em até um minuto.",
  "guardian.runNeedsAdmin": "Um administrador da organização roda o guardião sob demanda.",
  "guardian.workerOn": "Ativo no worker: {n} conexão(ões) Coolify vigiada(s), a cada {minutes} min.",
  "guardian.workerOff": "Inativo no worker: nenhuma conexão Coolify está em MAESTROS_ALLOW_REAL_COOLIFY_GUARDIAN, então nada é lido.",
  "guardian.workerUnknown": "Nenhum worker informou o guardião ainda.",
  "guardian.actionsOff": "Reiniciar e reimplantar não são enviados: a conexão não está em MAESTROS_ALLOW_REAL_COOLIFY_DEPLOY.",
  "guardian.lastRun": "Última verificação",
  "guardian.neverRun": "O guardião ainda não rodou.",
  "guardian.runSummary": "{when}: {services} serviço(s) verificado(s), {findings} achado(s), {opened} novo(s), {resolved} resolvido(s).",
  "guardian.runError": "Falhou: {error}",
  "guardian.runState.queued": "Na fila",
  "guardian.runState.running": "Rodando",
  "guardian.runState.succeeded": "Concluída",
  "guardian.runState.failed": "Falhou",
  "guardian.incidents": "Incidentes abertos",
  "guardian.noIncidents": "Nenhum incidente aberto: tudo o que o guardião vigia parece saudável.",
  "guardian.severity.critical": "Crítica",
  "guardian.severity.high": "Alta",
  "guardian.severity.medium": "Média",
  "guardian.severity.low": "Baixa",
  "guardian.service": "Serviço",
  "guardian.serviceKind.maestros": "MaestrOS",
  "guardian.serviceKind.published_app": "App publicado",
  "guardian.serviceKind.server": "Servidor",
  "guardian.seen": "Visto {n} vez(es), a última {when}",
  "guardian.regressed": "Voltou depois de resolvido",
  "guardian.evidence": "Evidência (com dados sensíveis ocultos)",
  "guardian.cause": "Causa",
  "guardian.fix": "Correção proposta",
  "guardian.explainedByModel": "Explicado pelo agente guardião",
  "guardian.explainedByRules": "Explicado pelas regras do detector",
  "guardian.fixKind.restart": "Reiniciar a aplicação (precisa da sua confirmação)",
  "guardian.fixKind.redeploy": "Reimplantar a aplicação (precisa da sua confirmação)",
  "guardian.fixKind.code_task": "Mudança de código: uma tarefa constrói, testa e revisa a correção",
  "guardian.fixKind.os_instructions": "Pacotes ou recursos do servidor: siga as instruções na VPS (o MaestrOS nunca executa)",
  "guardian.openTask": "Abrir a tarefa de correção",
  "guardian.restart": "Reiniciar",
  "guardian.redeploy": "Reimplantar",
  "guardian.confirmRestart": "Reiniciar {service}?",
  "guardian.confirmRedeploy": "Reimplantar {service}?",
  "guardian.confirmBody": "O worker pede ao Coolify (só quando a conexão tem permissão de escrita). Requisições em andamento nessa aplicação podem falhar durante o reinício. Esta ação fica registrada na auditoria.",
  "guardian.confirm": "Confirmar",
  "guardian.actionRequested": "Solicitado; o worker envia ao Coolify em até um minuto.",
  "guardian.lastAction": "Última ação: {action} — {state}",
  "guardian.actionState.requested": "aguardando o worker",
  "guardian.actionState.succeeded": "aceita pelo Coolify",
  "guardian.actionState.failed": "falhou",
  "guardian.actionState.not_sent": "não enviada",
  "guardian.actionsNeedAdmin": "Um administrador da organização confirma reinícios e reimplantações.",
};
